<template>
  <el-main class="rh-form">
    <form-fconttitreedit :routetolist="{ name: 'fcontinuetitres' }" />
  </el-main>
</template>
<script>
import FormFconttitreedit from "@/components/rh/formulaires/FormFconttitreedit";

export default {
  components: { "form-fconttitreedit": FormFconttitreedit },
};
</script>
